import languageIconStatic from "../../assets/icons/language/language.svg";
import languageIconHover from "../../assets/icons/language/languageHover.svg";
import closeIconStatic from "../../assets/icons/close.svg";
import closeIconHover from "../../assets/icons/closeHover.svg";

export const imgIcon = {
  languageIcon:  {
    static: languageIconStatic,
    hover: languageIconHover
  },
  closeIcon: {
    static: closeIconStatic,
    hover: closeIconHover
  }
}

export const buttonStyle = {
  static: {},
  hover:{animation: `slide-in-blurred-right 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) both`}
}
export const floatingAnimation = {
  animation: "floatingTab 6s 0.9s infinite linear",
}
export function AnimationRight(daley){
  const animationRight = {
    animation: `slide-in-blurred-right 0.6s ${daley}s cubic-bezier(0.230, 1.000, 0.320, 1.000) both`
  }
  return animationRight;
}
export function AnimationLeft(daley){
  const animationLeft = {
    animation: `slide-in-blurred-left  0.6s ${daley}s cubic-bezier(0.630, 1.000, 0.320, 1.000) both`,
    transform: "translateX(1000px) scaleX(2.5) scaleY(0.2)",
    transformOrigin:" 0% 50%",
    filter: "blur(40px)",
    opacity: 0,
  }
  return animationLeft;
}
